import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { Image } from '@app/shared/models/image.model';

@Injectable()
export class ImageService {
    handleBlobObservable(observable: Observable<Blob>, defaultIcon: string): Observable<Image> {
        return observable.pipe(
            catchError(() => {
                return of(null);
            }),
            map((blob) => {
                const data: Image = {
                    defaultIcon,
                };

                if (blob) {
                    data.source = URL.createObjectURL(blob);
                }

                return data;
            })
        );
    }
}
